import React from 'react';
import Bundle from './bundle';
import {getLanguage} from "../source/js/common";

const menuLan = require('../constant/js/formItemNameLabel/'+getLanguage()+'/menu.js');

export default [
    {
        path: '/login',
        exact: true,
        login:false,
        component(props) {
            return <Bundle {...props} load={() => import('../login')}/>;
        },
        breadcrumbName : 'login'
    },
    {
        path:"/faq_list",
        sitePath:"canvas/faq/faq_list",
        exact: true,
        login:false,
        component(props) {
            return <Bundle {...props} load={() => import('../faqs/Index')}/>;
        },
        breadcrumbName:"FAQs",
        children:[{
            path:"/faq_detail",
            exact:true,
            login:false,
            component(props) {
                return <Bundle {...props} load={() => import('../faqs/FaqDetail')}/>;
            },
            breadcrumbName:"FAQ Detail",
        }]
    },
    {
        path:"/policy_list",
        sitePath:"canvas/regulation/regulation_list",
        exact: true,
        login:false,
        component(props) {
            return <Bundle {...props} load={() => import('../policy/Index')}/>;
        },
        breadcrumbName:"Policy",
        children:[{
            path:"/policy_detail",
            exact:true,
            login:false,
            component(props) {
                return <Bundle {...props} load={() => import('../policy/PolicyDetail')}/>;
            },
            breadcrumbName:"Policy Detail",
        }]
    },
    {
        path:"/updateLogo",
        sitePath:"canvas/invoice/logo/logo_uploading",
        exact:true,
        login:true,
        component(props) {
            return <Bundle {...props} load={() => import('../logo/Index')}/>;
        },
        breadcrumbName:menuLan.updateLogo,
    },
    {
        path:"/logo",
        exact:true,
        login:true,
        ignoreAuthority:true,
        component(props) {
            return <Bundle {...props} load={() => import('../logo/Index')}/>;
        },
        breadcrumbName:menuLan.updateLogo,
    },
    {
        path: '/404',
        exact: true,
        login:false,
        component(props) {
            return <Bundle {...props} load={() => import('../404')}/>;
        },
        breadcrumbName : '404'
    },
    {
        path: '/noPermission',
        exact: true,
        login:false,
        component(props) {
            return <Bundle {...props} load={() => import('../noPermission')}/>;
        },
        breadcrumbName : menuLan.noPermission
    },
    {
        path: '/siteMap',
        login:false,
        exact: true,
        component(props) {
            return <Bundle {...props} load={() => import('../siteMap')}/>;
        },
        breadcrumbName : menuLan.siteMap,
    },
    {
        path: '/searchList',
        login:false,
        exact: true,
        component(props) {
            return <Bundle {...props} load={() => import('../searchList')}/>;
        },
        breadcrumbName : menuLan.searchList,
        children:[{
            path:"/faq_detail",
            exact:true,
            login:false,
            component(props) {
                return <Bundle {...props} load={() => import('../faqs/FaqDetail')}/>;
            },
            breadcrumbName:"FAQ Detail",
        },{
            path:"/policy_detail",
            exact:true,
            login:false,
            component(props) {
            return <Bundle {...props} load={() => import('../policy/PolicyDetail')}/>;
            },
            breadcrumbName:"Policy Detail",
        }]
    },
    {
        path: '/menuSearchList',
        login: false,
        exact: true,
        component(props) {
            return <Bundle {...props} load={() => import('../menuSearchList')}/>;
        },
        breadcrumbName : menuLan.searchList
    },
    {
        path: '/home',
        exact: true,
        login:true,
        component(props) {
            return <Bundle {...props} load={() => import('../home')}/>;
        },
        breadcrumbName : 'home'
    },
    {
        path: '/contactUs',
        exact: true,
        login:false,
        component(props) {
            return <Bundle {...props} load={() => import('../contactUs')}/>;
        },
        breadcrumbName : menuLan.contactUs,
    },
    {
        path: '/guideline',
        exact: true,
        login:false,
        component(props) {
            return <Bundle {...props} load={() => import('../guideline')}/>;
        },
        breadcrumbName : menuLan.guideline,
    },
    {
        path:"/transaction",
        sitePath:"/invoice/canvas/transactionDataManagement",
        exact: true,
        login: true,
        component(props) {
            return <Bundle {...props} load={() => import('../views/transaction/transactionManagement')}/>;
        },
        breadcrumbName:menuLan.transaction,
        children:[{
            path:"/transactionForm",
            exact:true,
            login:true,
            component(props) {
                return <Bundle {...props} load={() => import('../views/transaction/transactionForm')}/>;
            },
            breadcrumbName:menuLan.view,
        }, {
            path:"/OperationLog",
            exact:true,
            login:false,
            component(props) {
                return <Bundle {...props} load={() => import('../views/component/operationLog')}/>;
            },
            breadcrumbName: menuLan.operationLog,
        }, {
            path:"/invoiceIssuance",
            exact:true,
            login:true,
            component(props) {
                return <Bundle {...props} load={() => import('../views/invoice/invoiceIssuance')}/>;
            },
            breadcrumbName: menuLan.invoiceIssuance,
            children:[{
                path:"/selectBuyer",
                exact:true,
                login:true,
                component(props) {
                    return <Bundle {...props} load={() => import('../views/invoice/selectFrequentContacts')}/>;
                },
                breadcrumbName: menuLan.selectBuyer,
            },{
                path:"/selectSupplier",
                exact:true,
                login:true,
                component(props) {
                    return <Bundle {...props} load={() => import('../views/invoice/selectFrequentContacts')}/>;
                },
                breadcrumbName: menuLan.selectSupplier,
            },{
                path:"/addPayment",
                exact:true,
                login:true,
                component(props) {
                    return <Bundle {...props} load={() => import('../views/component/invoice/AddPayment')}/>;
                },
                breadcrumbName: menuLan.addPayment,
            }, {
                path:"/addAddition",
                exact:true,
                login:true,
                component(props) {
                    return <Bundle {...props} load={() => import('../views/component/invoice/addAddition')}/>;
                },
                breadcrumbName: menuLan.addAddition,
            },{
                path:"/modifyAddition",
                exact:true,
                login:true,
                component(props) {
                    return <Bundle {...props} load={() => import('../views/component/invoice/addAddition')}/>;
                },
                breadcrumbName: menuLan.modifyAddition
            }, {
                path:"/addTax",
                exact:true,
                login:true,
                component(props) {
                    return <Bundle {...props} load={() => import('../views/component/invoice/AddTax')}/>;
                },
                breadcrumbName: menuLan.addTax,
            },{
                path:"/modifyTax",
                exact:true,
                login:true,
                component(props) {
                    return <Bundle {...props} load={() => import('../views/component/invoice/AddTax')}/>;
                },
                breadcrumbName:menuLan.modifyTax,
            },{
                path:"/addItem",
                exact:true,
                login:true,
                component(props) {
                    return <Bundle {...props} load={() => import('../views/component/invoice/AddItem')}/>;
                },
                breadcrumbName:menuLan.addItem,
                children:[
                    {
                        path:"/selectGoods",
                        exact:true,
                        login:true,
                        component(props) {
                            return <Bundle {...props} load={() => import('../views/invoice/selectGoodsServices')}/>;
                        },
                        breadcrumbName: menuLan.selectGoods ,
                    },
                    {
                        path:"/addTax",
                        exact:true,
                        login:true,
                        component(props) {
                            return <Bundle {...props} load={() => import('../views/component/invoice/AddTax')}/>;
                        },
                        breadcrumbName: menuLan.addTax
                    },{
                        path:"/modifyTax",
                        exact:true,
                        login:true,
                        component(props) {
                            return <Bundle {...props} load={() => import('../views/component/invoice/AddTax')}/>;
                        },
                        breadcrumbName: menuLan.modifyTax
                    }
                ]
            },{
                path:"/modifyItem",
                exact:true,
                login:true,
                component(props) {
                    return <Bundle {...props} load={() => import('../views/component/invoice/AddItem')}/>;
                },
                breadcrumbName: menuLan.modifyItem,
                children:[
                    {
                        path:"/selectGoods",
                        exact:true,
                        login:true,
                        component(props) {
                            return <Bundle {...props} load={() => import('../views/invoice/selectGoodsServices')}/>;
                        },
                        breadcrumbName: menuLan.selectGoods,
                    },
                    {
                        path:"/addTax",
                        exact:true,
                        login:true,
                        component(props) {
                            return <Bundle {...props} load={() => import('../views/component/invoice/AddTax')}/>;
                        },
                        breadcrumbName:menuLan.addTax
                    },{
                        path:"/modifyTax",
                        exact:true,
                        login:true,
                        component(props) {
                            return <Bundle {...props} load={() => import('../views/component/invoice/AddTax')}/>;
                        },
                        breadcrumbName: menuLan.modifyTax
                    }
                ]
            }]
        }, {
            path:"/invoiceUpload",
            exact:true,
            login:true,
            component(props) {
                return <Bundle {...props} load={() => import('../views/invoice/invoiceUpload')}/>;
            },
            breadcrumbName: menuLan.invoiceUpload,
        }, {
            path:"/invoiceUploadRecords",
            exact:true,
            login:true,
            component(props) {
                return <Bundle {...props} load={() => import('../views/invoice/invoiceUploadRecords')}/>;
            },
            breadcrumbName:menuLan.invoiceUploadRecords,
        },{
            path:"/Issue",
            exact:true,
            login:true,
            component(props) {
                return <Bundle {...props} load={() => import('../views/invoice/invoiceIssue')}/>;
            },
            breadcrumbName: menuLan.add,
            children: [{
                    path:"/selectBuyer",
                    exact:true,
                    login:true,
                    component(props) {
                        return <Bundle {...props} load={() => import('../views/invoice/selectFrequentContacts')}/>;
                    },
                    breadcrumbName: menuLan.selectBuyer,
                },{
                    path:"/selectSupplier",
                    exact:true,
                    login:true,
                    component(props) {
                        return <Bundle {...props} load={() => import('../views/invoice/selectFrequentContacts')}/>;
                    },
                    breadcrumbName:menuLan.selectSupplier,
                },{
                    path:"/addPayment",
                    exact:true,
                    login:true,
                    component(props) {
                        return <Bundle {...props} load={() => import('../views/component/invoice/AddPayment')}/>;
                    },
                    breadcrumbName: menuLan.addPayment,
                 },{
                    path:"/addAddition",
                    exact:true,
                    login:true,
                    component(props) {
                        return <Bundle {...props} load={() => import('../views/component/invoice/addAddition')}/>;
                    },
                    breadcrumbName: menuLan.addAddition,
                },{
                    path:"/modifyAddition",
                    exact:true,
                    login:true,
                    component(props) {
                        return <Bundle {...props} load={() => import('../views/component/invoice/addAddition')}/>;
                    },
                    breadcrumbName:menuLan.modifyAddition
                }, {
                    path:"/addTax",
                    exact:true,
                    login:true,
                    component(props) {
                        return <Bundle {...props} load={() => import('../views/component/invoice/AddTax')}/>;
                    },
                    breadcrumbName:menuLan.addTax,
                },{
                    path:"/modifyTax",
                    exact:true,
                    login:true,
                    component(props) {
                        return <Bundle {...props} load={() => import('../views/component/invoice/AddTax')}/>;
                    },
                    breadcrumbName:menuLan.modifyTax
                },{
                    path:"/addItem",
                    exact:true,
                    login:true,
                    component(props) {
                        return <Bundle {...props} load={() => import('../views/component/invoice/AddItem')}/>;
                    },
                    breadcrumbName: menuLan.addItem,
                    children:[
                        {
                            path:"/selectGoods",
                            exact:true,
                            login:true,
                            component(props) {
                                return <Bundle {...props} load={() => import('../views/invoice/selectGoodsServices')}/>;
                            },
                            breadcrumbName: menuLan.selectGoods,
                        },
                        {
                            path:"/addTax",
                            exact:true,
                            login:true,
                            component(props) {
                                return <Bundle {...props} load={() => import('../views/component/invoice/AddTax')}/>;
                            },
                            breadcrumbName: menuLan.addTax
                        },{
                            path:"/modifyTax",
                            exact:true,
                            login:true,
                            component(props) {
                                return <Bundle {...props} load={() => import('../views/component/invoice/AddTax')}/>;
                            },
                            breadcrumbName: menuLan.modifyTax
                        }
                    ]
                },{
                path:"/modifyItem",
                exact:true,
                login:true,
                component(props) {
                    return <Bundle {...props} load={() => import('../views/component/invoice/AddItem')}/>;
                },
                breadcrumbName: menuLan.modifyItem,
                children:[
                    {
                        path:"/selectGoods",
                        exact:true,
                        login:true,
                        component(props) {
                            return <Bundle {...props} load={() => import('../views/invoice/selectGoodsServices')}/>;
                        },
                        breadcrumbName:menuLan.selectGoods,
                    },
                    {
                        path:"/addTax",
                        exact:true,
                        login:true,
                        component(props) {
                            return <Bundle {...props} load={() => import('../views/component/invoice/AddTax')}/>;
                        },
                        breadcrumbName: menuLan.addTax
                    },{
                        path:"/modifyTax",
                        exact:true,
                        login:true,
                        component(props) {
                            return <Bundle {...props} load={() => import('../views/component/invoice/AddTax')}/>;
                        },
                        breadcrumbName:menuLan.modifyTax
                    }
                ]
            }
            ]
        },{
            path:"/viewInvalidReasons",
            exact: false,
            login: false,
            ignoreAuthority:true,
            component(props) {
                return <Bundle {...props} load={() => import('../views/invoice/InvoiceInvalidReasons')}/>;
            },
            breadcrumbName:menuLan.viewInvalidReasons,
        }]
    },
    {
        path: "/purchase",
        sitePath: "/invoice/canvas/myPurchaseInvoices",
        exact: true,
        login: true,
        component(props) {
            return <Bundle {...props} load={() => import('../views/invoice/purchaseInvoice')}/>;
        },
        breadcrumbName: menuLan.purchase,
        children:[{
            path:"/rejectInvoice",
            exact:true,
            login:true,
            component(props) {
                return <Bundle {...props} load={() => import('../views/invoice/cancelOrReject')}/>;
            },
            breadcrumbName: menuLan.rejectInvoice,
        },{
            path:"/invoiceForm",
            exact:true,
            login:true,
            component(props) {
                return <Bundle {...props} load={() => import('../views/invoice/invoiceForm')}/>;
            },
            breadcrumbName:menuLan.view,
        }]
    },
    {
        path:"/invoice",
        sitePath:"/invoice/canvas/invoiceManagement",
        exact: true,
        login: true,
        component(props) {
            return <Bundle {...props} load={() => import('../views/invoice/invoiceManagement')}/>;
        },
        breadcrumbName:menuLan.invoice,
        children:[{
            path:"/invoiceForm",
            exact:true,
            login:true,
            component(props) {
                return <Bundle {...props} load={() => import('../views/invoice/invoiceForm')}/>;
            },
            breadcrumbName:menuLan.view,
        },{
            path:"/cancelInvoice",
            exact:true,
            login:true,
            component(props) {
                return <Bundle {...props} load={() => import('../views/invoice/cancelOrReject')}/>;
            },
            breadcrumbName:menuLan.cancelInvoice,
        },{
            path:"/shareInvoice",
            exact:true,
            login:true,
            component(props) {
                return <Bundle {...props} load={() => import('../views/invoice/invoiceShare')}/>;
            },
            breadcrumbName:menuLan.shareInvoice,
        },{
            path:"/viewInvalidReasons",
            exact: false,
            login: false,
            ignoreAuthority:true,
            component(props) {
                return <Bundle {...props} load={() => import('../views/invoice/InvoiceInvalidReasons')}/>;
            },
            breadcrumbName:menuLan.viewInvalidReasons,
        },{
            path:"/OperationLog",
            exact:true,
            login:false,
            component(props) {
                return <Bundle {...props} load={() => import('../views/component/operationLog')}/>;
            },
            breadcrumbName:menuLan.operationLog,
        },]
    },
    {
        path:"/myProfile",
        exact: true,
        login: true,
        ignoreAuthority:true,
        component(props) {
            return <Bundle {...props} load={() => import('../views/profile/MyProfile')}/>;
        },
        breadcrumbName:menuLan.myProfile,
        children:[{
            path:"/taxpayerInfo",
            exact:true,
            login:true,
            component(props) {
                return <Bundle {...props} load={() => import('../views/profile/TaxpayerInfo')}/>;
            },
            breadcrumbName:menuLan.taxpayerInfo,
            children: [{
                path: '/batchImportPage',
                exact: true,
                component(props) {
                    return <Bundle {...props} load={() => import('../views/profile/batchImportPage')}/>;
                },
                breadcrumbName : menuLan.batchImportPage
            }]
        },{
            path:"/taxpayerDetail",
            exact:true,
            login:true,
            component(props) {
                return <Bundle {...props} load={() => import('../views/profile/TaxpayerDetail')}/>;
            },
            breadcrumbName:menuLan.taxpayerDetail,
            children:[{
                path:"/contractView",
                exact:true,
                login:true,
                component(props) {
                    return <Bundle {...props} load={() => import('../views/profile/ContractView')}/>;
                },
                breadcrumbName:menuLan.contractView
            }]
        },{
            path:"/userBinding",
            exact:true,
            login:true,
            component(props) {
                return <Bundle {...props} load={() => import('../views/profile/UserBindingList')}/>;
            },
            breadcrumbName:menuLan.userBinding,
            children:[{
                path:"/roleManagement",
                exact:true,
                login:true,
                component(props) {
                    return <Bundle {...props} load={() => import('../views/profile/RoleList')}/>;
                },
                breadcrumbName:menuLan.roleManagement
            },{
                path:"/operationLog",
                exact:true,
                login:true,
                component(props) {
                    return <Bundle {...props} load={() => import('../views/profile/UserOperationLogList')}/>;
                },
                breadcrumbName:menuLan.viewOperationLog
            }]
        }]
    },{
        path:"/invoiceIssuance",
        exact: false,
        login: false,
        ignoreAuthority:true,
        component(props) {
            return <Bundle {...props} load={() => import('../views/invoice/h5/invoiceIssuance')}/>;
        },
        breadcrumbName:"",
    },{
        path:"/invoiceIssuanceBill",
        exact: false,
        login: false,
        ignoreAuthority:true,
        component(props) {
            return <Bundle {...props} load={() => import('../views/invoice/h5/invoiceIssuanceBill')}/>;
        },
        breadcrumbName:"",
    }, {
        path:"/debitNoteList",
        sitePath:"/invoice/canvas/invoice/debitNote",
        exact: true,
        login: true,
        component(props) {
            return <Bundle {...props} load={() => import('../views/invoice/debit/debitNoteList')}/>;
        },
        breadcrumbName:menuLan.debitNoteList,
        children:[{
            path:"/selectInvoiceList",
            exact:true,
            login:true,
            component(props) {
                return <Bundle {...props} load={() => import('../views/invoice/common/selectInvoiceList')}/>;
            },
            breadcrumbName:menuLan.selectInvoiceList,
            children:[{
                path:"/debitNoteForm",
                exact:true,
                login:true,
                component(props) {
                    return <Bundle {...props} load={() => import('../views/invoice/debit/debitNoteForm')}/>;
                },
                breadcrumbName:menuLan.debitNoteForm,
                children:[
                    {
                        path:"/addItem",
                        exact:true,
                        login:true,
                        component(props) {
                            return <Bundle {...props} load={() => import('../views/component/invoice/AddItem')}/>;
                        },
                        breadcrumbName:menuLan.addItem,
                        children:[
                            {
                                path:"/selectGoods",
                                exact:true,
                                login:true,
                                component(props) {
                                    return <Bundle {...props} load={() => import('../views/invoice/selectGoodsServices')}/>;
                                },
                                breadcrumbName:menuLan.selectGoods,
                            },
                            {
                                path:"/addTax",
                                exact:true,
                                login:true,
                                component(props) {
                                    return <Bundle {...props} load={() => import('../views/component/invoice/AddTax')}/>;
                                },
                                breadcrumbName:menuLan.addTax
                            },
                            {
                                path:"/modifyTax",
                                exact:true,
                                login:true,
                                component(props) {
                                    return <Bundle {...props} load={() => import('../views/component/invoice/AddTax')}/>;
                                },
                                breadcrumbName:menuLan.modifyTax
                            }
                        ]
                    },
                    {
                        path:"/modifyItem",
                        exact:true,
                        login:true,
                        component(props) {
                            return <Bundle {...props} load={() => import('../views/component/invoice/AddItem')}/>;
                        },
                        breadcrumbName:menuLan.modifyItem,
                        children:[
                            {
                                path:"/selectGoods",
                                exact:true,
                                login:true,
                                component(props) {
                                    return <Bundle {...props} load={() => import('../views/invoice/selectGoodsServices')}/>;
                                },
                                breadcrumbName:menuLan.selectGoods,
                            },
                            {
                                path:"/addTax",
                                exact:true,
                                login:true,
                                component(props) {
                                    return <Bundle {...props} load={() => import('../views/component/invoice/AddTax')}/>;
                                },
                                breadcrumbName:menuLan.addTax
                            },
                            {
                                path:"/modifyTax",
                                exact:true,
                                login:true,
                                component(props) {
                                    return <Bundle {...props} load={() => import('../views/component/invoice/AddTax')}/>;
                                },
                                breadcrumbName:menuLan.modifyTax
                            }
                        ]
                    },{
                        path:"/addAddition",
                        exact:true,
                        login:true,
                        component(props) {
                            return <Bundle {...props} load={() => import('../views/component/invoice/addAddition')}/>;
                        },
                        breadcrumbName:menuLan.addAddition
                    },{
                        path:"/modifyAddition",
                        exact:true,
                        login:true,
                        component(props) {
                            return <Bundle {...props} load={() => import('../views/component/invoice/addAddition')}/>;
                        },
                        breadcrumbName:menuLan.modifyAddition
                    }, {
                        path:"/addTax",
                        exact:true,
                        login:true,
                        component(props) {
                            return <Bundle {...props} load={() => import('../views/component/invoice/AddTax')}/>;
                        },
                        breadcrumbName:menuLan.addTax
                    },
                    {
                        path:"/modifyTax",
                        exact:true,
                        login:true,
                        component(props) {
                            return <Bundle {...props} load={() => import('../views/component/invoice/AddTax')}/>;
                        },
                        breadcrumbName:menuLan.modifyTax
                    }
                ]
            }]
        },{
            path:"/cancelDebitNote",
            exact:true,
            login:true,
            component(props) {
                return <Bundle {...props} load={() => import('../views/invoice/cancelOrReject')}/>;
            },
            breadcrumbName:menuLan.cancelInvoice
        },{
            path:"/viewDebitNote",
            exact:true,
            login:true,
            component(props) {
                return <Bundle {...props} load={() => import('../views/invoice/invoiceForm')}/>;
            },
            breadcrumbName:menuLan.view
        },{
            path:"/viewInvalidReasons",
            exact: false,
            login: false,
            ignoreAuthority:true,
            component(props) {
                return <Bundle {...props} load={() => import('../views/invoice/InvoiceInvalidReasons')}/>;
            },
            breadcrumbName:menuLan.viewInvalidReasons,
        }]
    },{
        path: "/credit",
        sitePath: "/invoice/canvas/creditNoteManagement",
        exact: true,
        login: true,
        component(props) {
            return <Bundle {...props} load={() => import('../views/invoice/credit/creditNoteManagement')}/>;
        },
        breadcrumbName: menuLan.credit,
        children:[{
            path:"/selectInvoiceList",
            exact:true,
            login:true,
            component(props) {
                return <Bundle {...props} load={() => import('../views/invoice/common/selectInvoiceList')}/>;
            },
            breadcrumbName:menuLan.selectInvoiceList,
            children:[{
                path:"/creditNoteForm",
                exact:true,
                login:true,
                component(props) {
                    return <Bundle {...props} load={() => import('../views/invoice/credit/creditNoteForm')}/>;
                },
                breadcrumbName:menuLan.creditNoteForm,
                children:[
                    {
                        path:"/addItem",
                        exact:true,
                        login:true,
                        component(props) {
                            return <Bundle {...props} load={() => import('../views/component/invoice/AddItem')}/>;
                        },
                        breadcrumbName:menuLan.addItem,
                        children:[
                            {
                                path:"/addTax",
                                exact:true,
                                login:true,
                                component(props) {
                                    return <Bundle {...props} load={() => import('../views/component/invoice/AddTax')}/>;
                                },
                                breadcrumbName:menuLan.addTax
                            }
                        ]
                    },
                    {
                        path:"/modifyItem",
                        exact:true,
                        login:true,
                        component(props) {
                            return <Bundle {...props} load={() => import('../views/component/invoice/AddItem')}/>;
                        },
                        breadcrumbName:menuLan.modifyItem,
                        children:[
                            {
                                path:"/selectGoods",
                                exact:true,
                                login:true,
                                component(props) {
                                    return <Bundle {...props} load={() => import('../views/invoice/selectGoodsServices')}/>;
                                },
                                breadcrumbName:menuLan.selectGoods,
                            },
                            {
                                path:"/addTax",
                                exact:true,
                                login:true,
                                component(props) {
                                    return <Bundle {...props} load={() => import('../views/component/invoice/AddTax')}/>;
                                },
                                breadcrumbName:menuLan.addTax
                            },
                            {
                                path:"/modifyTax",
                                exact:true,
                                login:true,
                                component(props) {
                                    return <Bundle {...props} load={() => import('../views/component/invoice/AddTax')}/>;
                                },
                                breadcrumbName:menuLan.modifyTax
                            }
                        ]
                    },
                    {
                        path:"/addTax",
                        exact:true,
                        login:true,
                        component(props) {
                            return <Bundle {...props} load={() => import('../views/component/invoice/AddTax')}/>;
                        },
                        breadcrumbName:menuLan.addTax
                    },
                    {
                        path:"/modifyTax",
                        exact:true,
                        login:true,
                        component(props) {
                            return <Bundle {...props} load={() => import('../views/component/invoice/AddTax')}/>;
                        },
                        breadcrumbName:menuLan.modifyTax
                    },{
                        path:"/modifyAddition",
                        exact:true,
                        login:true,
                        component(props) {
                            return <Bundle {...props} load={() => import('../views/component/invoice/addAddition')}/>;
                        },
                        breadcrumbName:menuLan.modifyAddition
                    }
                ]
            }]
        },{
            path:"/cancelCreditNote",
            exact:true,
            login:true,
            component(props) {
                return <Bundle {...props} load={() => import('../views/invoice/cancelOrReject')}/>;
            },
            breadcrumbName:menuLan.cancelInvoice
        },{
            path:"/viewCreditNote",
            exact:true,
            login:true,
            component(props) {
                return <Bundle {...props} load={() => import('../views/invoice/invoiceForm')}/>;
            },
            breadcrumbName:menuLan.view
        },{
            path:"/viewInvalidReasons",
            exact: false,
            login: false,
            ignoreAuthority:true,
            component(props) {
                return <Bundle {...props} load={() => import('../views/invoice/InvoiceInvalidReasons')}/>;
            },
            breadcrumbName:menuLan.viewInvalidReasons,
        }]
    } ,{
        path: "/refund",
        sitePath: "/invoice/canvas/refundNoteManagement",
        exact: true,
        login: true,
        component(props) {
            return <Bundle {...props} load={() => import('../views/invoice/refund/refundNoteManagement')}/>;
        },
        breadcrumbName: menuLan.refund,
        children:[{
            path:"/selectInvoiceList",
            exact:true,
            login:true,
            component(props) {
                return <Bundle {...props} load={() => import('../views/invoice/common/selectInvoiceList')}/>;
            },
            breadcrumbName:menuLan.selectInvoiceList,
            children:[{
                path:"/refundNoteForm",
                exact:true,
                login:true,
                component(props) {
                    return <Bundle {...props} load={() => import('../views/invoice/refund/refundNoteForm')}/>;
                },
                breadcrumbName:menuLan.refundNoteForm,
                children:[
                    {
                        path:"/addItem",
                        exact:true,
                        login:true,
                        component(props) {
                            return <Bundle {...props} load={() => import('../views/component/invoice/AddItem')}/>;
                        },
                        breadcrumbName: menuLan.addItem,
                        children:[
                            {
                                path:"/addTax",
                                exact:true,
                                login:true,
                                component(props) {
                                    return <Bundle {...props} load={() => import('../views/component/invoice/AddTax')}/>;
                                },
                                breadcrumbName:menuLan.addTax
                            }
                        ]
                    },
                    {
                        path:"/modifyItem",
                        exact:true,
                        login:true,
                        component(props) {
                            return <Bundle {...props} load={() => import('../views/component/invoice/AddItem')}/>;
                        },
                        breadcrumbName:menuLan.modifyItem,
                        children:[
                            {
                                path:"/selectGoods",
                                exact:true,
                                login:true,
                                component(props) {
                                    return <Bundle {...props} load={() => import('../views/invoice/selectGoodsServices')}/>;
                                },
                                breadcrumbName:menuLan.selectGoods,
                            },
                            {
                                path:"/addTax",
                                exact:true,
                                login:true,
                                component(props) {
                                    return <Bundle {...props} load={() => import('../views/component/invoice/AddTax')}/>;
                                },
                                breadcrumbName:menuLan.addTax
                            } ,{
                                path:"/modifyTax",
                                exact:true,
                                login:true,
                                component(props) {
                                    return <Bundle {...props} load={() => import('../views/component/invoice/AddTax')}/>;
                                },
                                breadcrumbName:menuLan.modifyTax
                            }
                        ]
                    },
                    {
                        path:"/addTax",
                        exact:true,
                        login:true,
                        component(props) {
                            return <Bundle {...props} load={() => import('../views/component/invoice/AddTax')}/>;
                        },
                        breadcrumbName:menuLan.addTax
                    },
                    {
                        path:"/modifyTax",
                        exact:true,
                        login:true,
                        component(props) {
                            return <Bundle {...props} load={() => import('../views/component/invoice/AddTax')}/>;
                        },
                        breadcrumbName:menuLan.modifyTax
                    },{
                        path:"/modifyAddition",
                        exact:true,
                        login:true,
                        component(props) {
                            return <Bundle {...props} load={() => import('../views/component/invoice/addAddition')}/>;
                        },
                        breadcrumbName:menuLan.modifyAddition
                    }
                ]
            }]
        },{
            path:"/cancelRefundNote",
            exact:true,
            login:true,
            component(props) {
                return <Bundle {...props} load={() => import('../views/invoice/cancelOrReject')}/>;
            },
            breadcrumbName:menuLan.cancelInvoice
        },{
            path:"/viewRefundNote",
            exact:true,
            login:true,
            component(props) {
                return <Bundle {...props} load={() => import('../views/invoice/invoiceForm')}/>;
            },
            breadcrumbName:menuLan.view
        },{
            path:"/viewInvalidReasons",
            exact: false,
            login: false,
            ignoreAuthority:true,
            component(props) {
                return <Bundle {...props} load={() => import('../views/invoice/InvoiceInvalidReasons')}/>;
            },
            breadcrumbName:menuLan.viewInvalidReasons,
        }]
    },{
        path: "/invoicingConsolidated",
        sitePath: "/invoice/canvas/invoicingConsolidated",
        exact: true,
        login: true,
        component(props) {
            return <Bundle {...props} load={() => import('../views/transactionConsolidated/transactionConsolidatedManagement')}/>;
        },
        breadcrumbName: menuLan.invoicingConsolidated,
        children:[{
            path:"/transactionConsolidatedForm",
            exact:true,
            login:true,
            component(props) {
                return <Bundle {...props} load={() => import('../views/transactionConsolidated/transactionConsolidatedForm')}/>;
            },
            breadcrumbName:menuLan.transactionConsolidatedForm,
            children: [{
                path:"/viewItem",
                exact:true,
                login:true,
                component(props) {
                    return <Bundle {...props} load={() => import('../views/component/invoice/AddItem')}/>;
                },
                breadcrumbName:menuLan.viewItem,
                children:[{
                    path:"/viewItemTax",
                    exact:true,
                    login:true,
                    component(props) {
                        return <Bundle {...props} load={() => import('../views/component/invoice/AddTax')}/>;
                    },
                    breadcrumbName:menuLan.viewItemTax
                }]
            },{
                path:"/viewTax",
                exact:true,
                login:true,
                component(props) {
                    return <Bundle {...props} load={() => import('../views/component/invoice/AddTax')}/>;
                },
                breadcrumbName:menuLan.viewTax,
            }]
        },{
            path:"/transactionSeparatedManagement",
            exact:true,
            login:true,
            component(props) {
                return <Bundle {...props} load={() => import('../views/transactionConsolidated/transactionSeparatedManagement')}/>;
            },
            breadcrumbName:menuLan.transactionSeparatedManagement,
            children:[{
                path:"/transactionForm",
                exact:true,
                login:true,
                component(props) {
                    return <Bundle {...props} load={() => import('../views/transaction/transactionForm')}/>;
                },
                breadcrumbName:menuLan.view,
            }]
        },{
            path:"/viewInvalidReasons",
            exact:false,
            login:false,
            component(props) {
                return <Bundle {...props} load={() => import('../views/invoice/InvoiceInvalidReasons')}/>;
            },
            breadcrumbName:menuLan.viewInvalidReasons,
        },{
            path:"/OperationLog",
            exact:true,
            login:false,
            component(props) {
                return <Bundle {...props} load={() => import('../views/component/operationLog')}/>;
            },
            breadcrumbName:menuLan.operationLog,
        },]
    } ,{
        path: "/report",
        sitePath: "/invoice/canvas/operationLogReport",
        exact: true,
        login: true,
        component(props) {
            return <Bundle {...props} load={() => import('../views/report/operationLogReport')}/>;
        },
        breadcrumbName: menuLan.report,
        children: [{
            path:"/operationDetails",
            exact: false,
            login: false,
            ignoreAuthority:true,
            component(props) {
                return <Bundle {...props} load={() => import('../views/report/operationDetails')}/>;
            },
            breadcrumbName:menuLan.viewDetails
        }]

    },{
        path: "/downloadTask",
        sitePath: "/invoice/canvas/downloadTask",
        exact: true,
        login: true,
        component(props) {
            return <Bundle {...props} load={() => import('../views/download/downloadTaskList')}/>;
        },
        breadcrumbName: menuLan.downloadTask,
        children: [{
            path:"/downloadTaskDetail",
            exact: false,
            login: false,
            ignoreAuthority:true,
            component(props) {
                return <Bundle {...props} load={() => import('../views/download/downloadTaskDetail')}/>;
            },
            breadcrumbName:menuLan.viewDetails
        }]

    },{
        path: "/goodsService",
        sitePath: "/invoice/canvas/goodsService",
        exact: true,
        login: true,
        component(props) {
            return <Bundle {...props} load={() => import('../views/goodsService/goodsServiceList')}/>;
        },
        breadcrumbName: menuLan.goodsService,
        children: [{
            path:"/addGoodsService",
            exact: true,
            login: true,
            ignoreAuthority:true,
            component(props) {
                return <Bundle {...props} load={() => import('../views/goodsService/goodsServiceForm')}/>;
            },
            breadcrumbName:menuLan.add,
            children:[
                {
                    path:"/addGoodsTax",
                    exact:true,
                    login:true,
                    component(props) {
                        return <Bundle {...props} load={() => import('../views/component/goods/AddGoodsTax')}/>;
                    },
                    breadcrumbName:menuLan.addGoodsTax
                },{
                    path:"/modifyGoodsTax",
                    exact:true,
                    login:true,
                    component(props) {
                        return <Bundle {...props} load={() => import('../views/component/goods/AddGoodsTax')}/>;
                    },
                    breadcrumbName:menuLan.modifyGoodsTax
                }
            ]
        },{
            path:"/modifyGoodsService",
            exact:true,
            login:true,
            component(props) {
                return <Bundle {...props} load={() => import('../views/goodsService/goodsServiceForm')}/>;
            },
            breadcrumbName:menuLan.modify,
            children:[
                {
                    path:"/addGoodsTax",
                    exact:true,
                    login:true,
                    component(props) {
                        return <Bundle {...props} load={() => import('../views/component/goods/AddGoodsTax')}/>;
                    },
                    breadcrumbName:menuLan.addGoodsTax
                },{
                    path:"/modifyGoodsTax",
                    exact:true,
                    login:true,
                    component(props) {
                        return <Bundle {...props} load={() => import('../views/component/goods/AddGoodsTax')}/>;
                    },
                    breadcrumbName:menuLan.modifyGoodsTax
                }
            ]
        }, {
            path: "/viewGoodsService",
            exact: true,
            login: true,
            component(props) {
                return <Bundle {...props} load={() => import('../views/goodsService/goodsServiceForm')}/>;
            },
            breadcrumbName: menuLan.view,
            children:[
                {
                    path:"/viewGoodsTax",
                    exact:true,
                    login:true,
                    component(props) {
                        return <Bundle {...props} load={() => import('../views/component/goods/AddGoodsTax')}/>;
                    },
                    breadcrumbName:menuLan.addTax
                }
            ]
        }, {
            path: '/batchImportPage',//商品维护批量导入
            exact: true,
            component(props) {
                return <Bundle {...props} load={() => import('../views/goodsService/batchImportPage')}/>;
            },
            breadcrumbName : menuLan.batchImportPage
        }]

    },{
        path: "/frequentContacts",
        sitePath: "/invoice/canvas/frequentContacts",
        exact: true,
        login: true,
        component(props) {
            return <Bundle {...props} load={() => import('../views/contacts/frequentContactsList')}/>;
        },
        breadcrumbName: menuLan.frequentContacts,
        children: [{
            path:"/add",
            exact: true,
            login: true,
            ignoreAuthority:true,
            component(props) {
                return <Bundle {...props} load={() => import('../views/contacts/frequentContactsForm')}/>;
            },
            breadcrumbName:menuLan.add
        },{
            path:"/modify",
            exact:true,
            login:true,
            component(props) {
                return <Bundle {...props} load={() => import('../views/contacts/frequentContactsForm')}/>;
            },
            breadcrumbName:menuLan.modify,
        }, {
            path: "/view",
            exact: true,
            login: true,
            component(props) {
                return <Bundle {...props} load={() => import('../views/contacts/frequentContactsForm')}/>;
            },
            breadcrumbName: menuLan.view
        }, {
            path: '/batchImportPage',
            exact: true,
            component(props) {
                return <Bundle {...props} load={() => import('../views/contacts/batchImportPage')}/>;
            },
            breadcrumbName : menuLan.batchImportPage
        }]

    },{
        path: "/consolidateTaskList",
        sitePath: "/invoice/canvas/transactionConsolidateTask",
        exact: true,
        login: true,
        component(props) {
            return <Bundle {...props} load={() => import('../views/consolidate/consolidateTaskList')}/>;
        },
        breadcrumbName: menuLan.consolidateTaskList,
        children: [{
            path:"/consolidateTaskForm",
            exact: true,
            login: true,
            ignoreAuthority:true,
            component(props) {
                return <Bundle {...props} load={() => import('../views/consolidate/consolidateTaskForm')}/>;
            },
            breadcrumbName:menuLan.consolidateTaskForm
        },{
            path:"/failureReason",
            exact: true,
            login: true,
            ignoreAuthority:true,
            component(props) {
                return <Bundle {...props} load={() => import('../views/consolidate/failureReason')}/>;
            },
            breadcrumbName:menuLan.failureReason
        }]
    }
];

